/**
 * Roles del sistema según el modelo entidad-relación (tabla ROLES).
 * Administrador: acceso completo.
 * Modulador: solo acceso a Gestión de donantes (donor-management).
 */
export const ROL_ADMINISTRADOR = 'Administrador';
export const ROL_MODULADOR = 'Modulador';

/** Ruta exclusiva para el rol Modulador */
export const RUTA_MODULADOR = '/donor-management';

/** Roles que tienen acceso completo (dashboard y todos los módulos) */
export const ROLES_ACCESO_COMPLETO = [ROL_ADMINISTRADOR];

/** Identifica si el rol solo puede acceder a gestión de donantes */
export function esRolSoloDonantes(rol: string | null): boolean {
  if (!rol) return false;
  const r = rol.trim().toLowerCase();
  return (
    r === ROL_MODULADOR.toLowerCase() || r === 'modulador' || r === '2' // IdRol típico de Modulador si la API envía ID
  );
}

/** Redirección por defecto tras login según rol */
export function rutaInicioPorRol(rol: string | null): string {
  return esRolSoloDonantes(rol) ? RUTA_MODULADOR : '/dashboard';
}
